// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__horZg","label":"Radio_label__13dQG","checkMark":"Radio_checkMark__AWDlP","disabled":"Radio_disabled__KW8UG"};